export interface MinuteOptionsConfig {
  min?: number;
  breakpoint?: number;
  smallStep?: number;
  largeStep?: number;
}

/**
 * Stepped minute options: `min .. breakpoint` by `smallStep`, then
 * `breakpoint + largeStep .. max` by `largeStep`. `max` is included only when it
 * lands on the large-step grid.
 */
export function buildMinuteOptions(max: number, config: MinuteOptionsConfig = {}): number[] {
  const { min = 1, breakpoint = 5, smallStep = 1, largeStep = 5 } = config;
  const options: number[] = [];
  for (let v = min; v <= breakpoint && v <= max; v += smallStep) {
    options.push(v);
  }
  for (let v = breakpoint + largeStep; v <= max; v += largeStep) {
    options.push(v);
  }
  return options;
}

/**
 * Nearest option to `value`; exact ties round to the lower option. Invalid/≤0 → first option.
 * `options` must be in ascending order — the tie-rounds-to-lower behavior depends on it.
 */
export function snapToNearest(value: number, options: number[]): number {
  if (!options.length) return value;
  if (!Number.isFinite(value) || value <= 0) return options[0];
  return options.reduce(
    (best, opt) => (Math.abs(opt - value) < Math.abs(best - value) ? opt : best),
    options[0],
  );
}
